import React from "react";
import { Container } from "reactstrap";
//Import Breadcrumb
import Entities from "./entityTable";


const EntityAndAddressMain = props => {
    //meta title
    document.title = "Entity | Fundlync";
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                        <Entities/>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EntityAndAddressMain
